'use client';

import ServiceContent from '@/components/services/ServiceContent';
import FAQContent from '@/components/services/FAQContent';
import faqData from '@/content/services/en/faq-data.json';

export default function FAQClient() {
    return (
        <ServiceContent>
            <FAQContent pageTitle={faqData.pageTitle} sections={faqData.sections} />
        </ServiceContent>
    );
}
